import { useNavigate } from "react-router-dom";
import { track } from "@amplitude/analytics-browser";
import { isEligibleRegion } from "../../campaigns/utils/campaign-utils";
import MISSION_IMG from "../../campaigns/assets/mission.png";

const MyMissionShortcut = () => {
  const navigate = useNavigate();
  const loadAddr = localStorage.getItem("loadAddr");
  const isEligible = isEligibleRegion(loadAddr);

  if (!isEligible) {
    return null;
  }

  return (
    <div className="px-4 mt-4">
      <div
        onClick={() => {
          track("미션할인 숏컷 클릭");
          navigate("/my-challenges");
        }}
        className="bg-white rounded-lg shadow-md p-4 cursor-pointer hover:shadow-lg transition-shadow flex items-center gap-3"
      >
        <img
          src={MISSION_IMG}
          alt="내미션"
          className="w-12 h-12 object-contain flex-shrink-0"
        />
        <div className="flex-1">
          <h3 className="font-semibold text-lg">내 미션</h3>
          <p className="text-sm text-gray-600">진행 중인 미션 확인</p>
        </div>
        <span className="text-gray-400">›</span>
      </div>
    </div>
  );
};

export default MyMissionShortcut;
